<template>
  <div class="d-activity-comment-activity activity">
    <div class="activity-top">
      <DActivityAvatar :activity="activity" />

      <div class="activity-title">
        <DActivityAuthor :activity="activity" />

        <span>
          commented on
          <DUserLinkPopup
            :slug="activity.source.slug"
            :url="activity.source.url"
          >
            <template slot="content">
              <a
                class="resource-link"
                :href="activity.source.url"
                target="_blank"
              >{{ sourceUsername }}</a>'s update
            </template>
          </DUserLinkPopup>
        </span>

        <DActivityTimestamp
          :activity="activity"
          class="visible-until-sm"
        />
      </div>

      <DActivityTimestamp
        :activity="activity"
        class="hidden-until-md"
      />
    </div>

    <div class="comment-box">
      <DTextWithLinks
        :content="activity.parent.body"
        :display-multiline="true"
        :mentions="activity.parent.mentions"
      />
    </div>
  </div>
</template>

<script>
import activityMixin from '../shared/activity-mixin';
import DTextWithLinks from '@d-components/d-text-with-links/d-text-with-links.vue';
import DUserLinkPopup from '@d-components/d-user-link-popup/d-user-link-popup.vue';

export default {
  components: {
    DUserLinkPopup,
    DTextWithLinks,
  },
  mixins: [
    activityMixin,
  ],
  data: () => ({
    sourceUsername: null,
  }),
  mounted() {
    const sourceUsername = this.activity.source.user.firstname ?
      `${ this.activity.source.user.firstname } ${ this.activity.source.user.lastname }` :
      this.activity.source.user;

    this.$set(this, 'sourceUsername', sourceUsername);
  },
};
</script>
